import { CommonController } from './CommonController';
import { OtherSlider } from '../modules/Slider';
import { HoverMoveImage } from '../modules/HoverMoveImage';
import { FilterInterview } from '../modules/Filter';
import { Validation } from '../modules/Validation';
import { AutoAddress } from '../modules/AutoAddress';

export class SubpageController extends CommonController {
  onInit() {
    super.onInit();
  }
  onLoad() {
    super.onLoad();
    new HoverMoveImage(); // interviewページ
    new OtherSlider(); // interviewページ
    new FilterInterview(); // interviewページ
    new Validation(); // Entryページ
    new AutoAddress(); // Entryページ
  }
  onDestroy() {
    super.onDestroy();
  }
}
